import React from "react";
import { PhaseDto } from "../../../../dtos/PhaseDto";
import { StepDto } from "../../../../dtos/StepDto";
import { useTaskListContext } from "../context/TaskListContext";
import { TaskActionsView } from "./components/TaskActionsView";
import { useTaskActionsController } from "./hooks/useTaskActionsController";

type ITaskActionsProps = {
    initialPhase: PhaseDto | null;
    grantNumber: string;
    steps: StepDto[] | null;
    onSelected?: () => void;
    editableTaskDates?: boolean;
};

export default function TaskActions(props: ITaskActionsProps) {
    const ctrl = useTaskActionsController(props);
    const { tasklistMode } = useTaskListContext();
    return <TaskActionsView {...ctrl} editableTaskDates={props.editableTaskDates} mode={tasklistMode} />;
}
